import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputAdornment, TextField } from '@mui/material';

const DropdownInput = ({
  anchorRef,
  onClick,
  title,
  error,
  selectedItem,
  searchTerm,
  onSearchChange,
  onClear,
  disabled = false
}) => {
  // Determine the value to show in the input field
  const inputValue = selectedItem?.value || searchTerm || '';

  return (
    <div className="categorized-input-wrapper">
      <label className="categorized-input-label">{title}</label>
      <TextField
        className="categorized-input"
        inputRef={anchorRef}
        onClick={onClick}
        value={inputValue} // Show selectedItem.value if available, otherwise show searchTerm
        onChange={(e) => onSearchChange(e.target.value)} // Update searchTerm when typing
        placeholder={`Search or manage ${title.toLowerCase()}`}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {inputValue && (
                <IconButton
                  size="small"
                  edge="end"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClear(); // Clear both searchTerm and selectedItem
                  }}
                  sx={{
                    padding: '4px',
                    opacity: disabled ? 0.5 : 1, // Apply opacity when disabled
                    cursor: disabled ? 'not-allowed' : 'pointer' // Change cursor when disabled
                  }}
                  disabled={disabled}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <ArrowDropDownIcon />
            </InputAdornment>
          )
        }}
        error={!!error}
        helperText={error?.message}
        size="small"
        fullWidth
        disabled={disabled}
      />
    </div>
  );
};

export default DropdownInput;
